import { motion } from "framer-motion";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function ZakatHome() {
    const {t}=useTranslation()
    const navigate=useNavigate();
  return (
    <motion.div
      className="flex flex-col items-center    w-11/12  xl:w-6/12 mx-auto overflow-hidden"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className="text-3xl font-bold text-emerald-700 mb-6"
        initial={{ y: -20 }}
        animate={{ y: 0 }}
        transition={{ delay: 0.2 }}
      >
            {t("ZakatCalculator")}
      </motion.div>

      <motion.div
        className="relative w-full h-72 md:w-11/12 xl:h-[28rem] rounded-xl overflow-hidden"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 100 }}
      >
        <motion.img
          className="w-full h-full  absolute inset-0"
          src="https://cdn.dribbble.com/userupload/13677831/file/original-e6bab036f334f40e8b1f2bdf1e861f18.gif"
          alt="Zakat illustration"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        />
      </motion.div>

      <motion.button
      onClick={()=>navigate("/zakat")}
        className=" px-8 py-3 bg-emerald-600 text-white font-semibold rounded-lg shadow-md hover:bg-emerald-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{
          opacity: { delay: 0.6 },
          y: { type: "spring", stiffness: 200 },
          scale: { type: "spring", stiffness: 300 },
        }}
      >
       {t("giveZakatNow")}
      </motion.button>
    </motion.div>
  );
}

export default ZakatHome;
